import { supportsLinearEasing } from './basler-components.es773.js';
import { generateLinearEasing } from './basler-components.es755.js';
import { cubicBezierAsString } from './basler-components.es771.js';
import { supportedWaapiEasing } from './basler-components.es774.js';
import { isBezierDefinition } from './basler-components.es775.js';

function mapEasingToNativeEasing(easing, duration) {
    if (!easing) {
        return undefined;
    }
    else if (typeof easing === "function") {
        return supportsLinearEasing()
            ? generateLinearEasing(easing, duration)
            : "ease-out";
    }
    else if (isBezierDefinition(easing)) {
        return cubicBezierAsString(easing);
    }
    else if (Array.isArray(easing)) {
        return easing.map((segmentEasing) => mapEasingToNativeEasing(segmentEasing, duration) ||
            supportedWaapiEasing.easeOut);
    }
    else {
        return supportedWaapiEasing[easing];
    }
}

export { mapEasingToNativeEasing };
